//#region Imports

import { ChangeDetectionStrategy, Component } from '@angular/core';
import { environment } from '../../../../environments/environment';

//#endregion

@Component({
    selector: 'l-ribbon',
    templateUrl: './ribbon.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RibbonComponent {

  //#region Constructor

  constructor() {
    if (environment.production)
      this.show = false;
    else if (environment.staging)
      this.name = 'Staging';
    else if (environment.qas)
      this.name = 'QAs';
    else
      this.name = 'Develop';
  }

  //#endregion

  //#region Public Properties

  public show: boolean = true;

  public name: string = '';

  //#endregion

}
